const getPathFromRequest = (req)=>{
    if (req.redirectPath) return req.redirectPath;
    // Use originalUrl (preserved by Express, never modified by Next.js)
    // since req.path is derived from req.url which Next.js 14 may rewrite
    const url = req.originalUrl || req.url || "";
    return url.split("?")[0] || "";
};
const getSearchParamsPathFromRequest = (req)=>{
    // Use originalUrl (preserved by Express) since req.url
    // may be rewritten by Next.js 14's app.render()
    const urlParts = (req.originalUrl || req.url || "").split("?");
    if (urlParts.length > 1) return urlParts[1];
    else return null;
};
const setRedirectPathOnRequest = (req, redirectPath)=>{
    req.redirectPath = redirectPath;
};
const setPageConfigOnRequest = (req, pageConfig)=>{
    req.pageConfig = pageConfig;
};
const setGeneratorSystemConfigOnRequest = (req, config)=>{
    req.systemConfig = config;
};
const getGeneratorSystemConfigOnRequest = (req)=>{
    return req.systemConfig;
};
const getPageConfigFromRequest = (req)=>{
    return req.pageConfig;
};
module.exports = {
    getPathFromRequest,
    setRedirectPathOnRequest,
    setGeneratorSystemConfigOnRequest,
    getGeneratorSystemConfigOnRequest,
    setPageConfigOnRequest,
    getPageConfigFromRequest,
    getSearchParamsPathFromRequest
};
